import * as React from 'react';
import AffiliatedEntitiesCore from '../AfrCore/AffiliatedEntitiesCore';

const AffiliatedEntities = (props:any) => {

    return (
        <React.Fragment>
            <AffiliatedEntitiesCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default AffiliatedEntities;